import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);


 export const requestPrefix = 'https://haiyun.hikoon.com:8446/manager';
//  export const requestPrefix = 'https://testtomcat.hikoon.com/butterfly-haiyun';
//  export const requestPrefix = 'http://127.0.0.1:8081/butterfly_web_war_exploded';

 


Vue.http.interceptors.push(function (request, next) {
  // console.log('admin',request.url.replace('market', 'manager'))
  // request.url = request.url.replace('market', 'manager');
  if(request.url.indexOf(requestPrefix) < 0){
    request.url = requestPrefix + request.url; 
  }
  next(function (response) {
    if(response.status === 401) {
      window.top.location.href = '/butterfly/admin/sign-in/index.html';
    }
  });
});

var actions = {
  
  /*交易管理*/
  admin_order_query: {method: 'POST', url: '/order'}, // 查询我的订购
  admin_order_op: {method: 'POST', url: '/order/op/{opType}'}, // 订单操作
  admin_get_order: {method: 'GET', url: '/order/{orderId}'}, // 获取
  admin_order_change_price: {method: 'POST', url: '/order/changePrice'}, // 获取
  admin_get_order_trace: {method: 'GET', url: '/order/orderTrace/{orderId}'}, // 获取
  admin_order_signed:{method:'POST',url:'/order/signed',emulateJSON: true}, // 订单完成签约

  admin_get_customer: {method: 'GET', url: '/customers/{id}'}, // 获取

  /*个人首页*/
  admin_get_statistics: {method:'GET',url:'/order/statistics'},//获取统计信息

  /* 登录 退出*/
  user_signIn: {method: 'POST', url: '/login'}, // 登录
  user_signOut: {method: 'POST', url: '/cust-logout'}, // 注销

  /*后台-经纪人*/
  users_manager_search: {method: 'POST', url: '/users', emulateJSON: true}, // 经纪人管理
  users_manager_sendEmail: {method: 'POST', url: '/user/{id}/activationMail', emulateJSON: true}, // 经纪人发送邮件
  users_manager_disable: {method: 'GET', url: '/user/disable/{id}'},//禁用
  users_manager_enable: {method: 'GET', url: '/user/enable/{id}'},//启用
  users_manager_deleteUser: {method: 'GET', url: '/user/delete/{id}'},//删除

  users_myprofile :{method:'GET',url : '/user/myprofile'}, //登录用户的资料
  users_modify_password :{method:'POST',url : '/user/my/password'}, //登录用户的资料
  users_modify_phone :{method:'POST',url : '/user/my/phone'}, //登录用户的资料
  users_modify_nickname :{method:'POST',url : '/user/my/nickname', emulateJSON: true}, //登录用户的资料

  user_tokenValid: {method: 'GET', url: '/user/token/valid', emulateJSON: true}, // 验证激活码
  user_activation: {method: 'PUT', url: '/user/{id}/activation'}, // 激活


  users_manager_add: {method: 'POST', url: '/users/create', emulateJSON: true}, // 创建经纪人
  users_manager_searchById: {method: 'GET', url: '/users/{id}'}, // 经纪人明细
  users_manager_edit: {method: 'POST', url: '/users/modify', emulateJSON: true}, // 更新经纪人
  /*后台-客户*/
  customer_manager_search: {method: 'POST', url: '/customers', emulateJSON: true}, // 客户管理
  customer_manager_sendEmail: {method: 'GET', url: '/customer/{id}/email/resend'}, // 客户发送邮件
  customer_manager_disable: {method: 'GET', url: '/customer/disable/{id}'},//禁用
  customer_manager_enable: {method: 'GET', url: '/customer/enable/{id}'},//启用
  customer_manager_deleteCustomer: {method: 'GET', url: '/customer/delete/{id}'},//删除

  customer_manager_add: {method: 'POST', url: '/customers/create', emulateJSON: true}, // 创建客户
  customer_manager_add2: {method: 'POST', url: '/customers/create2'}, // 创建客户
  customer_manager_searchById: {method: 'GET', url: '/customers/{id}'}, // 客户明细
  customer_manager_edit: {method: 'POST', url: '/customers/modify', emulateJSON: true}, // 更新客户
  customer_manager_edit2: {method: 'POST', url: '/customers/modify2'}, // 更新客户

  /*后台-作品管理*/
  song_manager_search: {method: 'POST', url: '/song/menagement', emulateJSON: true}, // 作品管理
  song_manager_batch_operate: {method: 'POST', url: '/song/batch/operation', emulateJSON: true}, // 批量操作
  song_manager_song_onsell: {method: 'GET', url: '/song/onsell/{id}'},
  song_manager_song_offsell: {method: 'POST', url: '/song/offsell', emulateJSON: true},
  song_manager_song_delete: {method: 'GET', url: '/song/delete/{id}'},
  song_manager_song_searchById: {method: 'GET', url: '/song/detail/{id}'},
  song_manager_song_submit: {method: 'POST', url: '/song', emulateJSON: true},
  song_manager_tag: {method: 'GET', url: '/song/tags'},
  song_musician_list: {method: 'GET', url: '/song/musician'},
  new_song_id: {method: 'GET', url: '/song/id'},
  song_lrc: {method: 'GET', url: '/song/lrc/{vendorId}/{id}', emulateJSON: true}, // 歌词
  song_desc: {method: 'GET', url: '/song/creation/{vendorId}/{id}', emulateJSON: true}, // 创作说明
  song_export_title: {method: 'GET', url: '/songExport/title', emulateJSON: true}, // 导出列数据返回

  /*后台-服务管理*/
  new_service_id: {method: 'GET', url: '/song/id'},
  service_manager_service_submit: {method: 'POST', url: '/service', emulateJSON: true},
  service_manager_search: {method: 'POST', url: '/service/management', emulateJSON: true},
  service_manager_service_onsell: {method: 'POST', url: '/service/onsell', emulateJSON: true},
  service_manager_service_offsell: {method: 'POST', url: '/service/offsell', emulateJSON: true},
  service_manager_service_delete: {method: 'POST', url: '/service/delete', emulateJSON: true},
  service_manager_batch_operate: {method: 'POST', url: '/service/batch/operation', emulateJSON: true},
  service_manager_searchById: {method: 'GET', url: '/service/detail/{id}'},


  /*后台-待入库作品管理*/
  original_song_manager_search:{method: 'POST', url: '/original/song/menagement', emulateJSON: true},
  original_song_manager_searchById:{method: 'GET', url: '/creation/song/detail/{id}'},
  original_song_manager_approve:{method: 'POST', url: '/original/song/approved',emulateJSON: true},
  original_song_manager_batch_approval:{method: 'POST', url: '/original/song/batch/approved',emulateJSON: true},
  original_song_manager_unapprove:{method: 'POST', url: '/original/song/unapprove',emulateJSON: true},
  original_song_manager_batch_disapproval:{method: 'POST', url: '/original/song/batch/unapprove',emulateJSON: true},
  original_song_manager_cancelSign:{method: 'POST', url: '/original/song/cancel',emulateJSON: true},
  original_song_manager_sign:{method: 'POST', url: '/original/song/signing',emulateJSON: true},
  original_song_lrc: {method: 'GET', url: '/original/song/lrc/{vendorId}/{id}', emulateJSON: true}, // 歌词
  original_song_desc: {method: 'GET', url: '/original/song/creation/{vendorId}/{id}', emulateJSON: true}, // 创作说明

  /* 后台-词曲人管理 */
  application_search: {method: 'GET', url: '/application/list'}, // 待入驻词曲人查询
  application_detail: {method: 'GET', url: '/application/{id}'}, // 待入驻词曲人详情
  application_approval: {method: 'POST', url: '/application/approval/{id}'}, // 审核通过
  application_agreemenet: {method: 'POST', url: '/application/agreement/{id}'}, // 完成签约
  musician_contract:{method: 'POST', url: '/contract/musician/{musicianId}',emulateJSON: true}, // 词曲人签约

  musician_list: {method: 'POST', url: '/musician',emulateJSON: true}, //词曲人查询
  musician_manager_sendEmail: {method: 'POST', url: '/musician/{id}/activationMail', emulateJSON: true}, // 经纪人发送邮件
  musician_manager_enable: {method: 'GET', url: '/musician/enable/{id}'},//启用
  musician_manager_disable: {method: 'GET', url: '/musician/disable/{id}'},//禁用
  musician_manager_deleteUser: {method: 'GET', url: '/musician/delete/{id}'},//删除
  musician_manager_create: {method: 'POST', url: '/musician/create'},//新建词曲人
  musician_get: {method: 'GET', url: '/musician/{id}'},//新建词曲人
  musician_modify: {method: 'POST', url: '/musician/modify'},//新建词曲人
  musician_get_masterwork: {method: 'GET', url: '/musician/masterworks/{id}'},//新建词曲人
  musician_export_title: {method: 'GET', url: '/musicianExport/title', emulateJSON: true}, // 导出列数据返回

  /* 回购作品 */
  buyback_orders: {method: 'POST', url: '/buybackorders'}, //查询回购单
  buyback_detail: {method: 'GET', url: '/buybackorders/{orderId}'}, // 回购单详情
  /* 公告 */
  notice_search: {method: 'POST', url: '/notice/search'}, // 查询公告
  notice_create: {method: 'POST', url: '/notice/create'}, // 创建公告
  notice_edit: {method: 'POST', url: '/notice/edit/{noticeId}'}, // 编辑公告
  notice_delete: {method: 'POST', url: '/notice/delete/{noticeId}'}, // 删除公告
  notice_detail: {method: 'GET', url: '/notice/{noticeId}'}, // 公告详情
  notices: {method: 'GET', url: '/notice/alldisplay'}, // 获取公告
  /* 忘记密码 */
  user_forgetPwd: {method: 'POST', url: '/user/forgotpassword'}, // 验证邮箱
  user_validresetcode: {method: 'POST', url: '/user/validresetcode'}, // 验证token
  user_resetpassword: {method: 'POST', url: '/user/resetpassword'}, // 设置新密码
  /* 合同 */
  contract_id :{method:'GET',url:'/contract/id'}, //获取合同ID
  contract_song: {method: 'POST', url: '/contract/song', emulateJSON: true}, // 作品签约
  contract_management: {method: 'POST', url: '/contract/management', emulateJSON: true}, // 合同管理
  contract_detail: {method: 'GET', url: '/contract/{id}'}, // 合同详情
  contract_preview: {method: 'GET', url: '/contract/preview/{id}'}, // 合同预览
  contract_download: {method: 'GET', url: '/contract/download/{id}'}, // 合同下载
  contract_cancel: {method: 'POST', url: '/contract/cancel', emulateJSON: true}, // 撤销合同
  contract_buyback: { method: 'POST', url: '/contract/buyback', emulateJSON: true }, // 回购下发合同
  
  /* 后台 */
  admin_get_case: { method: 'POST', url: '/bestCaseSongs/pageall' },//获取优秀案例列表
  admin_add_case: { method: 'POST', url: '/bestCaseSongs/add' }, //新增优秀案例
  admin_update_case: { method: 'POST', url: '/bestCaseSongs/update'}, //修改优秀案例
  admin_delete_case: { method: 'POST', url: '/bestCaseSongs/delete'}, //删除优秀案例
  admin_detail_case: {method: 'GET', url: '/bestCaseSongs/detail/{id}', emulateJSON: true}, //优秀案例详情
  
  admin_get_artist: { method: 'POST', url: '/coEntertainers/pagelist' },//获取合作艺人列表
  admin_add_artist: { method: 'POST', url: '/coEntertainers/add' },//新增合作艺人
  admin_update_artist: { method: 'POST', url: '/coEntertainers/update'}, //修改合作艺人
  admin_delete_artist: { method: 'POST', url: '/coEntertainers/delete' }, //删除合作艺人
  admin_detail_artist: {method: 'GET', url: '/coEntertainers/detail/{id}', emulateJSON: true}, //合作艺人详情

  admin_get_musician: { method: 'POST', url: '/musician/supplier/list' }, //获取供应商列表

  admin_add_musician: { method: 'POST', url: '/musician/supplier/save' }, //新增供应商
  admin_update_musician: { method: 'POST', url: '/musician/supplier/save' }, //修改供应商
  admin_get_musician_by_id: { method: 'get', url: '/musician/supplier/{id}' }, //查询单个供应商
  admin_del_musician: { method: 'get', url: '/musician/supplier/del/{id}' }, //删除供应商
  admin_connection_musician: { method: 'POST', url: '/musician/supplier/connection' }, //供应商关联艺人

  admin_get_musician_by_name: {method: 'POST', url: '/musician', emulateJSON: true}, //搜索合作艺人
  admin_get_log_module: {method: 'get', url: '/operationLog/module', emulateJSON: true}, //获取系统日志操作模块
  admin_get_log: {method: 'POST', url: '/operationLog/operationDate',emulateJSON: true}, //获取系统日志操作
  admin_recommendation_create: { method: 'POST', url: '/admin/recommendation/create' }, // 新增或修改音乐推荐任务
  admin_recommendation_get: { method: 'POST', url: '/admin/recommendation/list' }, // 获取推荐音乐列表

  admin_recommendation_suspend: { method: 'get', url: '/admin/recommendation/suspend/{id}' }, //暂停推荐
  admin_recommendation_resume: { method: 'get', url: '/admin/recommendation/resume/{id}' }, //恢复推荐
  admin_recommendation_cancel: { method: 'get', url: '/admin/recommendation/cancel/{id}' }, //取消推荐

  admin_musician_renew: {method: 'POST', url: '/contract/musicianRenew'}, //词曲人续约
  admin_recommendation_review: {method: 'POST', url: '/musician/recommendation/review'}, //审核词曲人的推荐申请
  admin_contract_refresh: {method: 'get', url: '/contract/refresh'}, //待入库作品手动刷新合同状态
  admin_offOrder_get: {method: 'POST', url: '/offOrder/list',emulateJSON: true}, // 下架中的作品
  admin_offOrder_refuse: {method: 'get', url: '/offOrder/refuse'}, //拒绝下架申请
  admin_offOrder_success: {method: 'get', url: '/offOrder/success'}, //通过下架申请
  admin_offOrder_detail: {method: 'get', url: '/offOrder/detail'}, //下架申请歌曲详情

  admin_get_mymenu_list: {method: 'GET', url: '/sys/user/menu/mymenu'}, // 获取当前用户的菜单列表
  admin_get_menu_list: {method: 'GET', url: '/sys/user/menu/list'}, // 获取全部菜单列表
  admin_get_role_list: {method: 'GET', url: '/sys/user/role/list'}, // 获取角列表
  admin_delete_role: {method: 'GET', url: '/sys/user/role/del/{id}'}, // 删除角色
  admin_find_role: {method: 'GET', url: '/sys/user/role/find/{id}'}, // 角色详情
  admin_save_update_role: {method: 'POST', url: '/sys/user/role/saveOrUpdate'}, // 添加/编辑角色
  admin_save_update_menu: {method: 'POST', url: '/sys/user/menu/saveOrUpdate'}, // 添加/编辑菜单



  admin_audition_add: {method: 'POST', url: '/audition/initiate',emulateJSON: true}, // 发起试听
  admin_audition_list: {method: 'POST', url: '/audition/list',emulateJSON: true}, // 试听会列表

  admin_updateFormerName: {method: 'POST', url: '/song/updateFormerName',emulateJSON: true}, // 更改歌曲名字
  admin_audition_auditionDetail: {method: 'GET', url: '/audition/auditionDetail?id={id}'}, // 试听会详情
  admin_audition_firstList: {method: 'GET', url: '/audition/firstList?id={id}'}, // 试听会初审列表
  admin_audition_checkAuditStatus: {method: 'GET', url: '/audition/checkAuditStatus'}, //实时查看试听会歌曲审核状态
  admin_audition_firstAudit: {method: 'POST', url: '/audition/firstAudit',emulateJSON: true}, // 初审
  admin_audition_endAudit: {method: 'GET', url: '/audition/endAudit?id={id}'}, //结束试听会
  admin_audition_finalList: {method: 'GET', url: '/audition/finalList?id={id}'}, // 试听会终审列表
  admin_audition_checkToFinalAudition: {method: 'GET', url: '/audition/checkAudition?id={id}'}, // 手动改为待终审
  admin_audition_finalAudit: {method: 'POST', url: '/audition/finalAudit',emulateJSON: true}, // 终审
  admin_customerView_totalData: {method: 'GET', url: '/customerView/totalData'}, // 客户总览数据
  admin_customerView_customerData: {method: 'GET', url: '/customerView/customerData'}, // 客户视图数据
  admin_audition_secondAudit: {method: 'POST', url: '/audition/secondAudit',emulateJSON: true}, // 二审
  admin_audition_secondList: {method: 'GET', url: '/audition/secondList?id={id}'}, // 试听会二审列表

  song_repeatNameCheck: {method: 'GET', url: '/song/repeatNameCheck?name={name}'}, // 歌曲名重复判断(海酝使用接口)

  //歌单
  sheet_list: {method: 'POST', url: '/sheet/list',emulateJSON: true}, // 歌单列表
  sheet_changeStatus: {method: 'POST', url: '/sheet/changeStatus',emulateJSON: true}, // 歌单上架/下架/删除
  sheet_detail: {method: 'GET', url: '/sheet/detail?id={id}'}, // 歌单详情
  sheet_fileUpload: {method: 'POST', url: '/sheet/fileUpload',emulateJSON: true}, // 歌单封面上传
  sheet_image: {method: 'GET', url: '/sheet/image/{sheetId}'}, // 歌单封面下载
  sheet_addOrUpdate: {method: 'POST', url: '/sheet/addOrUpdate'}, // 新增歌单/修改歌单
  sheet_deleteSongs: {method: 'POST', url: '/sheet/deleteSongs',emulateJSON: true}, // 移除歌单中的歌曲
  // sheet_addSongs: {method: 'POST', url: '/sheet/addSongs',emulateJSON: true}, // 新增歌单中的歌曲
  sheet_addSongsList: {method: 'POST', url: '/sheet/addSongsList',emulateJSON: true}, // 新增歌单中的歌曲列表
};

var resource = Vue.resource('', {}, actions, {credentials: true});

export default resource;



// WEBPACK FOOTER //
// ./src/admin/common/resource.js